module.exports = __webpack_public_path__ + "img/高亮网络3.1748138f.svg";